<template>
  <div>
    <el-form ref="form" :model="form" label-width="120px" style="form" :rules="rules">
      <el-form-item label="分类名称" prop="typeName">
        <el-input v-model="form.typeName" style="width:100%"></el-input>
      </el-form-item>
      <el-form-item label="分类说明">
        <el-input type="infoExplain" v-model="form.infoExplain" style="width:100%"></el-input>
      </el-form-item>
      <div class="button" v-if="buttonType!='compile'">
        <el-button type="primary" @click="save">添加</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
      <div class="button" v-if="buttonType=='compile'">
        <el-button type="primary" @click="save">添加</el-button>
        <el-button type="success" @click="edit">编辑</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
    </el-form>
    <el-table :data="tableData" border style="width: 100%;margin:30px 0px" align="center">
      <el-table-column prop="typeName" label="分类名称"></el-table-column>
      <el-table-column prop="infoExplain" label="分类说明"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="compile(scope.row)" type="success" size="small">编辑</el-button>
          <el-button @click="handleDelete(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import uploadImgs from "@/component/uploadImgs/index.vue";
import request from "@/utils/request.js";
import {
  ConsultTypeList,
  ConsultTypeEdit,
  ConsultTypeDelete,
} from "../api/index.js";
import { findAddressByParentId } from "@/api/http";
import AMap from "AMap"; // 引入高德地图
export default {
  props: ["title", "buttonType", "row"],
  data() {
    return {
      form: {},
      rules: {
        typeName: [
          { required: true, message: "请填写分类名称", trigger: "blur" },
        ],
      },
      tableData: [],
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
      currentPage: 1,
    };
  },
  methods: {
    //保存按钮
    save(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            delete this.form.id;
          }
          ConsultTypeEdit(this.form).then((res) => {
            this.$message({
              type: "success",
              message: "添加成功!",
            });
            this.form = {};
            this.ConsultTypeListAPI();
          });
        }
      });
    },
    //编辑
    edit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          ConsultTypeEdit(this.form).then((res) => {
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.ConsultTypeListAPI();
          });
        }
      });
    },
    //编辑按钮
    compile(e) {
      this.buttonType = "compile";
      this.form = JSON.parse(JSON.stringify(e));
    },
    //取消
    cancel(e) {
      this.$emit("cancel");
    },
    //删除
    handleDelete(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          ConsultTypeDelete({ id: e.id }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.ConsultTypeListAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //拿到政策分类的列表
    ConsultTypeListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      ConsultTypeList(params).then((res) => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //每页请求数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.ConsultTypeListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      });
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.ConsultTypeListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      });
    },
  },
  created() {
    this.ConsultTypeListAPI();
  },
};
</script>

<style scoped >
.left {
  width: 45%;
  display: inline-block;
}
.right {
  width: 45%;
  display: inline-block;
  /* float: right; */
}
.flex {
  display: flex;
}
.itemSelect {
  width: 30%;
}
.map {
  width: 100%;
  height: 120px;
  background-color: red;
}
.button {
  width: 400px;
  margin: 10px auto 0px;
  display: flex;
  justify-content: space-between;
}
.title {
  border: 1px solid rgb(175, 175, 175);
  text-align: center;
  padding: 10px 0px;
  margin: 10px 0px;
}
.el-form-item__content {
  display: flex !important;
}
.el-form-item {
  margin-bottom: 20px !important;
}
</style>